import { httpsCallable } from 'firebase/functions'
import { isNoSignInPreviewActive } from '../debug'
import { firebaseFunctions } from './firebase'
import type { AutomationAction } from '../types/automation'

export type AutomationActionExecutionEntry = {
  actionId: string
  type: AutomationAction['type']
  outcome: 'SUCCESS' | 'FAILED'
  errorMessage?: string
}

export type AutomationActionExecutionResult = {
  runId: string
  outcome: 'SUCCESS' | 'FAILED' | 'SKIPPED'
  entries: AutomationActionExecutionEntry[]
  errorMessage: string | null
}

type ExecuteAutomationActionBundleInput = {
  workspaceId: string
  name: string
  description?: string
  sourcePrompt?: string
  actions: AutomationAction[]
}

export const executeAutomationActionBundle = async (
  input: ExecuteAutomationActionBundleInput,
): Promise<AutomationActionExecutionResult> => {
  if (isNoSignInPreviewActive()) {
    return {
      runId: `debug-manual-${Date.now()}`,
      outcome: 'SUCCESS',
      entries: input.actions.map((action) => ({
        actionId: action.id,
        type: action.type,
        outcome: 'SUCCESS',
      })),
      errorMessage: null,
    }
  }
  const callable = httpsCallable<ExecuteAutomationActionBundleInput, AutomationActionExecutionResult>(
    firebaseFunctions,
    'executeAutomationActionBundle',
  )
  return (await callable(input)).data
}
